module.exports = __webpack_public_path__ + "img/icn_check_kizu.74513489.png";